import type { FolderAccessPayload } from '@octopus-do/octopus-api-client'
import { call, delay, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import {
  type FolderAccessRequestAction,
  InternalFolderActions,
} from '../../actions'

const REQUEST_TIMEOUT = 1000

export function* folderAccessRequest({
  payload: { workspaceId, id, visibility, members: payloadMembers },
}: ReturnType<typeof FolderAccessRequestAction>) {
  yield delay(REQUEST_TIMEOUT)

  // todo: move to backend
  const members = visibility === 'public' ? [] : payloadMembers

  const response: FolderAccessPayload = yield call(
    NestClient.folders.access,
    workspaceId,
    {
      id: Number.parseInt(id, 10),
      visibility,
      members,
    }
  )

  yield put(
    InternalFolderActions.update({
      workspaceId,
      id,
      data: { members: response.members, visibility: response.visibility },
    })
  )
}
